export default "__VITE_ASSET__B7yf$ih2__"